export const addStateReset =
  (...types: string[]) =>
  <T, A extends { type: string }>(reducer: (state: T, action: A) => T, initialState: T) =>
  (state: T, action: A) =>
    types.includes(action.type) ? initialState : reducer(state, action);
